import React from 'react';
import PropTypes from 'prop-types';

const Form = (props) => {
    const setFieldHandler = (event) => {
        props.setField(event.target.name, event.target.value);
        props.setSignUp();
    }

    const handleLogin = (type) => {
        props.login(type);
    };

    const keyPressHandler = (type, event) => {
        if (event.key === 'Enter') {
            props.login(type);
        }
    };

    const forgotPasswordHandler = (type, event) => {
        event.preventDefault();
        props.restorePassword(type);
    };

    const handleSignUp = (type) => {
        props.setSignUp(type);
        props.showMessageModal();
    };

    return (
        <div className="form-container">
            <h2>Welcome to your online product ordering and design portal.</h2>
            <div className="logins-container">
                <div className="login-container">
                    <div className="logo utp-logo">
                        <img src="https://ac-ut-health.s3.amazonaws.com/css/UTHH-UTP-logo-140524.png" alt="UTP" />
                    </div>
                    <div className="fields">
                        <div className="field">
                            <div>Email <span className="required">*</span>:</div>
                            <input type="text" name="email1" value={props.form.email1} onChange={setFieldHandler} onKeyPress={keyPressHandler.bind(this, 5)} />
                        </div>
                        <div className="field">
                            <div>Password <span className="required">*</span>:</div>
                            <input type="password" name="password1" value={props.form.password1} onChange={setFieldHandler} onKeyPress={keyPressHandler.bind(this, 5)} />
                        </div>
                    </div>
                    <div className="text-right">
                        <button
                            type="button"
                            onClick={handleLogin.bind(this, 5)}
                            disabled={props.loginType === 5 && props.isLogging}
                        >
                            {props.loginType === 5 && props.isLogging ? <i className="fas fa-circle-notch fa-spin"></i> : 'Login'}
                        </button>
                    </div>
                    <div className="actions-container">
                        <div className="forgot-password" onClick={forgotPasswordHandler.bind(this, 1)}>Forgot your password?</div>
                        <div className="create-account" onClick={handleSignUp.bind(this, 5)}>Create Account</div>
                    </div>
                </div>
                <div className="login-container">
                    <div className="logo uth-logo">
                        <img src="https://ac-ut-health.s3.amazonaws.com/uth-logo-02-08-2022.png" alt="UTH" />
                    </div>
                    <div className="fields">
                        <div className="field">
                            <div>Email <span className="required">*</span>:</div>
                            <input type="text" name="email2" value={props.form.email2} onChange={setFieldHandler} onKeyPress={keyPressHandler.bind(this, 6)} />
                        </div>
                        <div className="field">
                            <div>Password <span className="required">*</span>:</div>
                            <input type="password" name="password2" value={props.form.password2} onChange={setFieldHandler} onKeyPress={keyPressHandler.bind(this, 6)} />
                        </div>
                    </div>
                    <div className="text-right">
                        <button
                            type="button"
                            onClick={handleLogin.bind(this, 6)}
                            disabled={props.loginType === 6 && props.isLogging}
                        >
                            {props.loginType === 6 && props.isLogging ? <i className="fas fa-circle-notch fa-spin"></i> : 'Login'}
                        </button>
                    </div>
                    <div className="actions-container">
                        <div className="forgot-password" onClick={forgotPasswordHandler.bind(this, 2)}>Forgot your password?</div>
                        <div className="create-account" onClick={handleSignUp.bind(this, 6)}>Create Account</div>
                    </div>
                </div>
            </div>
            <div className="disclaimer1">
                Disclaimer: The site you are entering is for individual purchases of UT Physicians/UTHealth branded apparel and promotional items for personal use.
                First-time users will need to create an account before making any purchases. The login and password are not associated with your university credentials.
                **The site is also for managers who need to purchase required polo shirts to be charged to Clinical Operations.
            </div>
            <div className="disclaimer2">
                If you are authorized to make a purchase for a department or clinic using university funding, please log onto your COUPA account.
                The online store has been seamlessly integrated with COUPA for business purchases.
            </div>
        </div>
    );
}

Form.propTypes = {
    isLogging: PropTypes.bool.isRequired,
    setField: PropTypes.func.isRequired
}

export default Form;
